import { SDKError } from "@smash-sdk/core";
export class GenericError extends SDKError {
}
export class MissingSenderError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "MissingSenderError";
    }
}
export class MissingReceiversError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "MissingReceiversError";
    }
}
export class InvalidDeliveryError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidDeliveryError";
    }
}
export class InvalidAvailabilityDurationError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidAvailabilityDurationError";
    }
}
export class InvalidParameterError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidParameterError";
    }
}
export class UnauthorizedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "UnauthorizedError";
    }
}
export class PasswordDoesNotMatchError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "PasswordDoesNotMatchError";
    }
}
export class InvalidSubscriptionError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidSubscriptionError";
    }
}
export class EmailNotAllowedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "EmailNotAllowedError";
    }
}
export class OwnerUsageExceededError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "OwnerUsageExceededError";
    }
}
export class PasswordRequiredError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "PasswordRequiredError";
    }
}
export class TeamConfigurationError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "TeamConfigurationError";
    }
}
export class DropboxDisabledError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "DropboxDisabledError";
    }
}
export class DropboxDeletedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "DropboxDeletedError";
    }
}
export class DropboxMaxTransferCountError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "DropboxMaxTransferCountError";
    }
}
export class DropboxMaxBytesUploadedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "DropboxMaxBytesUploadedError";
    }
}
export class NotFoundError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "NotFoundError";
    }
}
export class CustomUrlAlreadyInUseError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "CustomUrlAlreadyInUseError";
    }
}
export class InternalServerError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InternalServerError";
    }
}
export class BadGatewayError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "BadGatewayError";
    }
}
export class GatewayTimeoutError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "GatewayTimeoutError";
    }
}
export default {
    GenericError,
    MissingSenderError,
    MissingReceiversError,
    InvalidDeliveryError,
    InvalidAvailabilityDurationError,
    InvalidParameterError,
    UnauthorizedError,
    PasswordDoesNotMatchError,
    InvalidSubscriptionError,
    EmailNotAllowedError,
    OwnerUsageExceededError,
    PasswordRequiredError,
    TeamConfigurationError,
    DropboxDisabledError,
    DropboxDeletedError,
    DropboxMaxTransferCountError,
    DropboxMaxBytesUploadedError,
    NotFoundError,
    CustomUrlAlreadyInUseError,
    InternalServerError,
    BadGatewayError,
    GatewayTimeoutError,
};
